import React from "react";
import { Phone, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const HERO_ATTORNEY_IMAGE = "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/Generated-MIL.webp";
export default function Professionallawhero() {
  const stats = [{
    value: "Florida & New York",
    label: "Admitted to Practice"
  }, {
    value: "Since 1983",
    label: "Member of The Florida Bar"
  }, {
    value: "U.S. Supreme Court",
    label: "Admitted"
  }, {
    value: "Former Chair",
    label: "FL Bar Grievance Committee"
  }];
  return <section data-section-id="257521" id="professionallawhero" className="bg-background text-foreground relative w-full overflow-hidden">
      {}
      <div className="container mx-auto px-4 max-w-[1200px] py-16 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          {}
          <div className="space-y-8 lg:pl-8 xl:pl-12">
            <div className="text-secondary font-default font-semibold tracking-widest uppercase text-sm mb-4">
              Hollywood, Florida
            </div>
            
          <h1 className="text-4xl sm:text-5xl lg:text-[45px] leading-[1.08] font-serif font-semibold text-primary max-w-[600px]">Experienced South Florida Counsel for Business, Real Estate, Trust and Probate Matters</h1>
            
            <p className="text-lg font-sans text-muted-foreground max-w-lg leading-relaxed">For more than four decades, Morrie I. Levine has advised South Florida clients in business, real estate, trust and probate matters, selected disputes, and attorney's fee proceedings. His practice is informed by experience with both the documents that govern a matter and the disputes that arise when those documents are later interpreted or challenged.</p>
            
            <div className="flex flex-wrap gap-4 pt-2">
              <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground rounded-md px-8 h-14 text-base shadow-md">
                <Link to="/ContactUsPage">
                  Request a Consultation
                </Link>
              </Button>
            </div>
            
            {}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 pt-10 border-t border-border/60">
              {stats.map((stat, i) => <div key={i} data-index={i} className="space-y-1">
                  <div className="text-xl font-serif font-bold text-primary leading-tight">{stat.value}</div>
                  <div className="text-xs font-sans text-muted-foreground font-medium uppercase tracking-wider">{stat.label}</div>
                </div>)}
            </div>
          </div>

          {}

          <div className="relative h-[400px] sm:h-[500px] lg:h-[650px] w-full rounded-lg overflow-hidden shadow-xl bg-warm-gray/30">
            <img alt="Morrie I. Levine - Principal Attorney" className="w-full h-full object-cover object-[68%_center]" src={HERO_ATTORNEY_IMAGE} src="https://morrielevine.com/wp-content/uploads/2026/06/Generated-MIL.png" />
            <div className="absolute inset-0 bg-primary/5 pointer-events-none" />
          </div>

        </div>
      </div>

      {}
      <div className="bg-primary text-primary-foreground py-5 border-t-4 border-secondary">
        <div className="container mx-auto px-4 max-w-[1200px] flex flex-col md:flex-row items-center justify-between gap-6">
          
          <div className="flex items-center gap-4">
            <div>
              <div className="text-lg font-bold font-serif tracking-wide">Expert Witness Services</div>
              <div className="text-sm text-primary-foreground/80 font-sans mt-0.5">Objective analysis of reasonable hourly rates, time spent, work performed, and attorney's fee and cost claims.</div>
            </div>
          </div>
          
          <div className="flex flex-wrap items-center justify-center gap-4 w-full md:w-auto">
            <Button asChild className="bg-secondary hover:bg-secondary/90 text-secondary-foreground rounded-md px-6 shadow-sm">
              <Link to="/AttorneyFeeHearingsPage">Attorney's Fee Hearings Page</Link>
            </Button>
            
            <Button asChild variant="outline" className="border-primary-foreground/30 text-primary-foreground hover:bg-primary-foreground hover:text-primary rounded-md px-6 bg-transparent">
              <Link to="tel:+19549259000" className="inline-flex items-center">
                <Phone className="mr-2 size-4" /> Phone: (954) 925-9000
              </Link>
            </Button>
            <Button asChild variant="outline" className="border-primary-foreground/30 text-primary-foreground hover:bg-primary-foreground hover:text-primary rounded-md px-6 bg-transparent">
              <Link to="mailto:info@morrielevine.com" className="inline-flex items-center">
                <Mail className="mr-2 size-4" /> Email: info@morrielevine.com
              </Link>
            </Button>
          </div>

        </div>
      </div>
    </section>;
}